import {
  ESSENTIALS_MENU_ITEM,
  ProductLicenseKeysEnum,
  SUBJECT_AREA_ITEMS,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";
import { PopoutMenuSection } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/PopoutMenuSection";
import { PopoutSectionItem } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/PopoutSectionItem";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";
import useGetUserExperimentSegment from "@/features/useGetUserExperimentSegment";

const SubjectsMenuPopoutSection = () => {
  const { data: user } = useUser();
  const {
    activeELALicense,
    activeSSLicense,
    activeScienceLicense,
    activeEssentialsLicense,
    isStudent,
  } = getUserProperties(user, { shouldUseNewUserApi: false });
  const [showLockIconsExperiment] =
    useGetUserExperimentSegment("show_lock_icons");
  const showLicenseItemWithLock = showLockIconsExperiment === "on";
  const licensesMap = {
    [ProductLicenseKeysEnum.SS]: activeSSLicense,
    [ProductLicenseKeysEnum.ELA]: activeELALicense,
    [ProductLicenseKeysEnum.SCI]: activeScienceLicense,
  };

  return (
    <PopoutMenuSection title="Subjects" width="15.625rem">
      {activeEssentialsLicense && (
        <PopoutSectionItem
          href={ESSENTIALS_MENU_ITEM.href}
          title={ESSENTIALS_MENU_ITEM.title}
          SvgComponent={ESSENTIALS_MENU_ITEM.SvgComponent}
          locked={false}
          dataQASelector={ESSENTIALS_MENU_ITEM.dataQASelector}
        />
      )}
      {SUBJECT_AREA_ITEMS.filter(
        ({ license }) =>
          licensesMap[license] || (showLicenseItemWithLock && !isStudent),
      ).map(({ title, href, SvgComponent, license, dataQASelector }, index) => (
        <PopoutSectionItem
          key={index}
          href={href}
          title={title}
          SvgComponent={SvgComponent}
          locked={!licensesMap[license]}
          dataQASelector={dataQASelector}
        />
      ))}
    </PopoutMenuSection>
  );
};

SubjectsMenuPopoutSection.displayName = "SubjectsMenuPopoutSection";
export { SubjectsMenuPopoutSection };
